export default {"src":"/_next/static/media/ao.5358ad4f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};